import * as React from 'react';
import * as selectors from './selectors'
import { connect } from 'react-redux';
import { AppState, Dispatch } from '../../types';
import { SupportedRuntimesTooltipResolver } from '../../util/SupportedRuntimesHelper';
import { transformToEnvironmentSelectorProps } from '../../common/environment/model';
import { transformToResourceSelectorProps } from '../../common/resource/model';
import MonitoringLandingPage, { ValueProps, EventProps } from '../../common/components/MonitoringLandingPage/MonitoringLandingPage';
import { RawDataLandingPageSvg } from './RawDataLandingPageSvg';
import { ResourceType } from '@mulesoft/monitoring-center-components/lib/models/resource';
import { environmentSelected, landingOnLoad, onLandingView, resourceSelected } from './actions';

const mapStateToProps = (state: AppState): ValueProps => {
  return {
    title: 'Raw Data',
    subTitle: 'Export application archived log data to your local machine. Select an application to get started',
    footer: <SupportedRuntimesTooltipResolver/>,
    image: <RawDataLandingPageSvg data-test-id="raw-data-landing-image"/>,
    environmentSelector:
        transformToEnvironmentSelectorProps(selectors.getEnvironmentSelector.getAll(state), 25, 'log-points-environment-selector'),
    resourceSelector:
        transformToResourceSelectorProps(selectors.getResourceSelector.getAll(state), 40, 'log-points-resource-selector'),
    versionSelector: {isLoading: false, maxLength: 35},
    testIds: {
      title: 'landing-page-title',
      subTitle: 'landing-page-subtitle',
      image: 'raw-data-landing-image',
      footer: ''
    }
  }
}

const mapDispatch = (dispatch: Dispatch): EventProps => ({
  componentWillMount: () => dispatch(landingOnLoad()),
  environmentSelected: (environmentId: string) => dispatch(environmentSelected(environmentId)),
  resourceSelected: (resourceId: string, resourceType: ResourceType) => dispatch(resourceSelected(resourceId, resourceType)),
  versionSelected: (_: string) => undefined,
  onView: (environmentId: string, resourceId: string) => dispatch(onLandingView(environmentId, resourceId)),
});

export default connect(mapStateToProps, mapDispatch)(MonitoringLandingPage)
